<template>
  <div id="extra-component-form-wizard-demo">
    <vs-row vs-type="flex" vs-justify="center" class="mt-8">
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-md="10"
        vs-lg="10"
        vs-sm="12"
      >
        <form-wizard-icon-tab
          :preSaleMode="preSaleMode"
          :preSaleLocationNumber="preSaleLocationNumber"
        ></form-wizard-icon-tab>
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" vs-justify="center" class="mt-8">
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-md="10"
        vs-lg="10"
        vs-sm="12"
      >
        <img
          src="@/assets/images/logo/logo2.png"
          alt="Logo"
          style="max-width: 200px; position: relative"
        />
      </vs-col>
    </vs-row>

    <footer class="the-footer flex-wrap justify-center">
      <p></p>
      <span class="md:flex items-center">
        <span class="sm:inline-block"
          >&copy; {{ new Date().getFullYear() }} De idea a realidad por
          &nbsp;</span
        >
        <a href="https://mayfer.dev/" target="_blank" rel="nofollow">MAYFER</a>
      </span>
    </footer>
  </div>
</template>

<script>
import FormWizardIconTab from "./FormWizardIconTabRegister.vue";

export default {
  components: {
    FormWizardIconTab,
  },
  props: {
    preSaleMode: {
      type: Boolean,
      default: false,
    },
    preSaleLocationNumber: {
      type: [String, Number],
      default: null,
    },
  },
};
</script>
